import { Container, Grid, IconButton, Tooltip } from "@material-ui/core";
import React, { Fragment, useEffect, useState } from "react";
import { Auth } from "aws-amplify";
import EmailOutlinedIcon from "@material-ui/icons/EmailOutlined";
import ExitToAppIcon from "@material-ui/icons/ExitToAppOutlined";
import AccountCircleIcon from "@material-ui/icons/AccountCircleOutlined";
async function signOut() {
  try {
    await Auth.signOut({ global: true });
  } catch (error) {
    console.log("error signing out: ", error);
  }
}
const Header: React.FC<any> = ({ theme, dataset }) => {
  return (
    <Grid item style={{ paddingBottom: 20, marginTop: 60 }}>
      <img src="/img/logos/dvc.png" alt="Logo" style={{ height: 60 }} />
      <div style={{ float: "right", paddingTop: 20 }}>
        <Tooltip title="Contact">
          <IconButton>
            <EmailOutlinedIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Preferences">
          <IconButton>
            <AccountCircleIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Sign Out">
          <IconButton
            onClick={() => {
              signOut();
            }}
          >
            <ExitToAppIcon />
          </IconButton>
        </Tooltip>
      </div>
    </Grid>
  );
};

export default Header;
